(function(w,d,$){
  'use strict';

  $(function(){

    // トップページカスタム
    $.topInit();



    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr:{
            class:'button block-btn'
          }
        },
        title:{
          html: '<span>NEWS</span><small>お知らせ</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          const img = $this.find('.thum_img>img')[0] || {src:'/image/underconstruction.gif'},
                $thumb_img = $('<img />',{src:img.src,class:'thumb_img'}),
                $thumb = $('<figure />',{class:'item-image',style:'background-image:url('+img.src+')'}).append($thumb_img),
                $desc = $('<div />',{class:'item-desc'});
          $this.find('table').remove();
          $desc
            .append( $date )
            .append( $catetitle )
            .append( $new )
            .append( $title )
            .append( $catch )
            .append( $body );
          $this
            .append( $thumb )
            .append( $desc );
          // $date.insertAfter( $catetitle );
        }
      },
      // 'works':{
      //   title:{
      //     html: '<span>WORKS</span><small>施工事例</small>' // プレーンテキストで動的にする場合は false
      //   },
      //   itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
      //     $this
      //       .append( $title.append($new) )
      //       .append( $catetitle )
      //       .append( $date )
      //       .append( $catch )
      //       .append( $body );
      //     // $date.insertAfter( $catetitle );
      //   }
      // },
    }));




    $('[data-plugin=getArticle]').each(function(){

      var $this = $(this),
          moduleInfo = {
            content: $this.data('content'),
            module: $this.data('module')
          },
          categories = $.getCategory(moduleInfo),
          articles = $.getArticle(moduleInfo),
          classbase = 'p-works-block__',
          post_count = $this.data('postCount');

      // ajax終わったら実行
      $.when(categories,articles).done(function(categories,articles){

        var $list = $this;

        $list.empty();  // 初期化
        // 記事ループ
        $.each(articles,function(i,item){
          if( i >= post_count ) return;
          var cate = categories.filter(function(v, i){ if (v.id == item.category) return true }),
              $item =   $('<a />', {class:classbase+'item',href:'/'+moduleInfo.content+'/?mode=detail&article='+item.id}),
              $cont =   $('<figure />', {class:classbase+'image'}).css({'background-image':'url('+item.thumb+')'}),
              $image =  $('<img />', {width:200,height:200,src:item.thumb}),
              $cap =    $('<figcaption />', {class:classbase+'cap'}),
              $category=(cate.length)? $('<a />', {class:'category',href:'/'+moduleInfo.content+'/?mode=list&cat='+item.category}).text(cate[0].name) :false,
              $title =  $('<span />', {class:'title'}).text(item.title),
              $desc =   $('<span />', {class:'desc'}).text(item.desc);
          $cap
            .append($category)
            .append($title);
            // .append($desc);
          $cont
            .append($image)
            .append($cap);
          $item.append($cont);
          $item.appendTo($list);
        });
      });
    });




  });

  $(w).on('mainImage.load',function(){

    $('[data-plugin="slider"]').each(function(){
      const $this = $(this);
      $this.children('img').each(function(){
        const imgpath = this.src;
        const $wrapper = $('<div />',{class:'slider-item'}).css('backgroundImage','url('+imgpath+')');
        $(this).addClass('hidden').wrap($wrapper);
      });
      $this.slick({
        dots:true,
        arrows:false,
        autoplay:true,
        autoplaySpeed:4000,
        fade:true,
        speed:2000,
        pauseOnHover:false
      });
    });

  });

}(window,document,jQuery));